<script setup lang="ts">
import Inquiry from '@/javascripts/utils/inquiry';
import SlideIndicator from './slide_indicator.vue';

const emit = defineEmits(['next', 'back']);

const props = defineProps<{
  inquiry: Inquiry,
  currentSlideIndex: number,
}>();

const emitNextIfUnchanged = function(clicked: boolean) {
  if (props.inquiry.dispensingExperience == clicked) {
    emit('next');
  }
}
</script>

<template>
  <div class="inner_content inner_step">
    <div class="main_content step_content">
      <SlideIndicator :current-slide-index="currentSlideIndex" />
      <h2>調剤業務の経験はありますか？</h2>
      <div class="box_step_btn box_step_btn_p01">
        <div class="step_btn">
          <label for="dispensing_experience_true">
            <input
              id="dispensing_experience_true"
              v-model="inquiry.dispensingExperience"
              type="radio"
              name="dispensing_experience"
              :value="true"
              @change="emit('next')"
              @click="emitNextIfUnchanged(true)"
            >
            <p>経験あり</p>
          </label>
        </div>
        <div class="step_btn">
          <label for="dispensing_experience_false">
            <input
              id="dispensing_experience_false"
              v-model="inquiry.dispensingExperience"
              type="radio"
              name="dispensing_experience"
              :value="false"
              @change="emit('next')"
              @click="emitNextIfUnchanged(false)"
            >
            <p>経験なし</p>
          </label>
        </div>
      </div>
      <div class="box_btn_nextback">
        <div class="btn_back">
          <button @click.once="emit('back')">
            <span>戻る</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
